"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.WarningIcon = (0, react_1.forwardRef)(function WarningIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { 
            // eslint-disable-next-line max-len
            d: "M4.48242 20.334H19.8047C21.3184 20.334 22.2949 19.2109 22.2949 17.834C22.2949 17.4238 22.1875 17.0039 21.9727 16.6133L14.2969 2.90234C13.8281 2.05273 12.9883 1.62305 12.1484 1.62305C11.3086 1.62305 10.459 2.05273 9.99023 2.90234L2.32422 16.6133C2.10938 17.0137 1.99219 17.4238 1.99219 17.834C1.99219 19.2109 2.96875 20.334 4.48242 20.334ZM12.1582 13.6152C11.582 13.6152 11.25 13.293 11.2305 12.7168L11.0938 7.83398C11.0742 7.22852 11.5039 6.80859 12.1484 6.80859C12.7734 6.80859 13.2324 7.23828 13.2129 7.84375L13.0566 12.707C13.0371 13.3027 12.7148 13.6152 12.1582 13.6152ZM12.1582 16.9941C11.4941 16.9941 10.9473 16.5156 10.9473 15.8711C10.9473 15.2266 11.4844 14.748 12.1582 14.748C12.8223 14.748 13.3594 15.2266 13.3594 15.8711C13.3594 16.5254 12.8125 16.9941 12.1582 16.9941Z", fill: "currentColor" })));
});
